import get from 'lodash/get';
import * as pianoPageActions from '../../action_creators/piano/piano_page_action_creators';
import asyncRecircFeedActions from '../async_recirc_feed_actions';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import log from '../../../services/logger_service';

export default function fetchPianoPage(params, store) {
  return function firstPianoPageDispatch(dispatch) {
    dispatch(pianoPageActions.pianoPageLoading());
    return Promise.all([asyncRecircFeedActions(params, store)(dispatch)])
      .then(function handlePianoPageData() {
        dispatch(pianoPageActions.pianoPageLoaded({}, store));
        return true;
      })
      .catch(function handlePianoageError(err) {
        const status = get(err, 'response.status') || 500;
        if (status === 404) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        } else {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(
            err,
            `Error in piano page actions, message: ${err.message}`
          );
        }
        dispatch(pianoPageActions.pianoPageLoadError(err, store));
      });
  };
}
